"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LAYERS = exports.getLayerProps = void 0;

var _deck = require("deck.gl");

var _iconClusterLayer = _interopRequireDefault(require("../../icon-cluster-layer"));

var _BarLayer = _interopRequireDefault(require("../customlayers/BarLayer"));

var _JSUtils = require("../../JSUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addOptionsToObject = function addOptionsToObject(opt, obj) {
  Object.keys(opt).forEach(function (key) {
    obj[key] = opt[key];
  });
  return obj;
};

var makeObject = function makeObject(type, min, max, def, step) {
  return {
    type: type,
    min: min,
    max: max,
    "default": def,
    step: step
  };
};

var options = {
  pickable: {
    type: 'boolean',
    value: true
  },
  extruded: {
    type: 'boolean',
    value: true
  }
};
var layers = {};
var hexObject = {
  "class": {
    value: _deck.HexagonLayer,
    type: 'class'
  },
  extruded: {
    type: 'boolean',
    value: true
  },
  radius: makeObject('number', 50, 1000, 100, 50),
  elevationScale: makeObject('number', 1, 8, 1, 2)
};
layers['hex'] = addOptionsToObject(options, hexObject);
var scatterObj = {
  "class": {
    value: _deck.ScatterplotLayer,
    type: 'class'
  },
  opacity: makeObject('number', 0, 1, 0.8, 0.1),
  getRadius: makeObject('number', 10, 1000, 30, 10),
  radiusScale: makeObject('number', 0, 1, 0.8, 0.1),
  radiusMinPixels: makeObject('number', 1, 10, 1, 1),
  radiusMaxPixels: makeObject('number', 1, 100, 100, 5)
};
layers['scatterplot'] = addOptionsToObject(options, scatterObj);
var geojsonObject = {
  "class": {
    value: _deck.GeoJsonLayer,
    type: 'class'
  },
  pickable: {
    type: 'boolean',
    value: true
  },
  extruded: {
    type: 'boolean',
    value: false
  },
  stroked: {
    type: 'boolean',
    value: false
  },
  filled: {
    type: 'boolean',
    value: true
  },
  lineWidthScale: makeObject('number', 20, 100, 20, 5),
  lineWidthMinPixels: makeObject('number', 2, 20, 2, 2),
  getRadius: makeObject('number', 10, 1000, 30, 10),
  getLineWidth: makeObject('number', 1, 10, 1, 1),
  getElevation: makeObject('number', 30, 100, 30, 10)
};
layers['geojson'] = geojsonObject;
var iconObject = {
  "class": {
    value: _iconClusterLayer["default"],
    type: 'class'
  },
  wrapLongitude: {
    type: 'boolean',
    value: false
  }
};
layers['icon'] = addOptionsToObject(options, iconObject);
var sgridObject = {
  "class": {
    value: _deck.ScreenGridLayer,
    type: 'class'
  },
  cellSizePixels: makeObject('number', 50, 100, 50, 5)
};
layers['sgrid'] = addOptionsToObject(options, sgridObject);
var gridObject = {
  "class": {
    value: _deck.GridLayer,
    type: 'class'
  },
  cellSize: makeObject('number', 100, 5000, 100, 50),
  elevationScale: makeObject('number', 4, 10, 4, 2)
};
layers['grid'] = addOptionsToObject(options, gridObject);
var lineObject = {
  "class": {
    value: _deck.LineLayer,
    type: 'class'
  }
};
layers['line'] = addOptionsToObject(options, lineObject);
var arcObject = {
  "class": {
    value: _deck.ArcLayer,
    type: 'class'
  }
};
layers['arc'] = addOptionsToObject(options, arcObject);
var pathObject = {
  "class": {
    value: _deck.PathLayer,
    type: 'class'
  }
};
layers['path'] = addOptionsToObject(options, pathObject);
var heatObject = {
  "class": {
    value: _deck.HeatmapLayer,
    type: 'class'
  },
  getWeight: {
    type: 'column',
    value: 'number',
    "default": 1
  }
};
layers['heatmap'] = addOptionsToObject(options, heatObject);
var textObject = {
  "class": {
    value: _deck.TextLayer,
    type: 'class'
  }
};
layers["text"] = addOptionsToObject(options, textObject);
var barvisObject = {
  "class": {
    value: _BarLayer["default"],
    type: 'class'
  },
  getRotationAngle: {
    type: 'column',
    value: 'number',
    "default": 1
  },
  getWidth: {
    type: 'column',
    value: 'number',
    "default": 1
  }
};
layers["barvis"] = addOptionsToObject(options, barvisObject);
var pointCloudObject = {
  "class": {
    value: _deck.PointCloudLayer,
    type: 'class'
  },
  pointSize: makeObject('number', 1, 100, 10, 2),
  opacity: makeObject('number', 0, 1, 0.5, 0.1)
};
layers["pointcloud"] = addOptionsToObject(options, pointCloudObject);

var getLayerProps = function getLayerProps(name) {
  if (!(0, _JSUtils.isString)(name)) return null;
  return Object.freeze(layers[name]);
};

exports.getLayerProps = getLayerProps;
var LAYERS = Object.keys(layers);
exports.LAYERS = LAYERS;